import type {
  CatalogProductDetail,
  AdminCatalogProductsResponse,
} from '@printtat/shared';
import { apiJson } from '@/lib/apiFetch';

export const catalogApi = {
  async list(query?: {
    search?: string;
    category?: string;
    page?: number;
    limit?: number;
  }): Promise<AdminCatalogProductsResponse> {
    const params = new URLSearchParams();
    if (query?.search) params.set('search', query.search);
    if (query?.category) params.set('category', query.category);
    if (query?.page) params.set('page', String(query.page));
    if (query?.limit) params.set('limit', String(query.limit));
    const qs = params.toString() ? `?${params.toString()}` : '';
    // Public endpoint — skipAuth to avoid sending a stale token.
    return apiJson<AdminCatalogProductsResponse>(`/catalog-products${qs}`, {
      skipAuth: true,
    });
  },

  async detail(slug: string): Promise<CatalogProductDetail> {
    return apiJson<CatalogProductDetail>(
      `/catalog-products/${encodeURIComponent(slug)}`,
      { skipAuth: true },
    );
  },

  async fork(catalogProductId: string): Promise<{ designId: string }> {
    return apiJson<{ designId: string }>(
      `/catalog-products/${catalogProductId}/fork`,
      { method: 'POST' },
    );
  },
};
